import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import numeral from 'numeral';
import React, { useState, useRef, useLayoutEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import "assets/css/grid_table.css";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import { Tooltip } from "primereact/tooltip";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import axios from "axios";

const SystemOptions  = () => {
  let emptyRow = {
    organization_id: "",
    organization_code: "",
    allow_negative_inventory_mean: "",
    intransit_subinventory_code: "",
    default_ht_aging_hours: "",
    default_rt_aging_hours: "",
    auto_start_mg_shift_hrs_bef: "",
    auto_end_mg_shift_hrs_aft: "",
    tpa_default_day_running_time: "",
    pdcs_start_eff_date: "",
    conc_pgm_pdcs_user_name: "",
    conc_pgm_rpt_user_name: "",
    conc_pgm_rpt_resp_name: "",
    conc_pgm_rpt_resp_appl_name: "",
    log_prefix_name: "",
    enable_db_log_meaning: "",
    default_tpa_bag_quantity: "",
    max_tpa_bag_quantity: "",
    keep_plc_poll_hist_days: "",
    no_of_purge_days: "",
    commit_batch_size: "",
    poll_data_arch_host_name: "",
    poll_data_arch_port_number: "",
    poll_data_arch_ftp_user: "",
    poll_data_arch_ftp_password: "",
    poll_data_dxp_host_name: "",
    poll_data_dxp_port_number: "",
    poll_data_dxp_ftp_user: "",
    poll_data_dxp_ftp_password: "",
    poll_data_dxp_remote_base_dir: "",
    poll_data_dxp_local_base_dir: "",
    dxp_dlog_logging_path: "",
    dxp_dlog_csv_domain: "",
    dxp_dlog_csv_uid: "",
    dxp_dlog_csv_pwd: "",
    poll_data_dxp_reftp_hours: ""

  };

  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [visiblePassword, setVisiblePassword] = useState({});
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isPasswordVisible1, setIsPasswordVisible1] = useState(false);
  const [isPasswordVisible2, setIsPasswordVisible2] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  
  // Fetch Machines when the component mounts
    const fetchRows = async () => {
      try {
        setIsLoading(true);
        const response = await loadApi("","/api/setup/systemOptions/selRows");
        console.log("Fetched Data:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = response.data[2];

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    };
 useLayoutEffect(() => {
  if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
  }
  }, []);


  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
}

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="row d-flex justify-content-center m-5">
        <div className="col-auto">
          <div className="card shadow-sm border-primary">
            <div className="card-header bg-primary text-white">
              <h2 className="mb-0">
              System Options
              </h2>
            </div>
            <div className="card-body text-center">
              <h3>
                <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                The page is loading...
              </h3>
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      System Options 
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );

  const HTTemplate = (rowData) => {
    return numeral(rowData.default_ht_aging_hours).format('0,0');
  }
  const RTTemplate = (rowData) => {
    return numeral(rowData.default_rt_aging_hours).format('0,0');
  }
  const MGBeforeTemplate = (rowData) => {
    return numeral(rowData.auto_start_mg_shift_hrs_bef).format('0,0');
  }
  const MGAfterTemplate = (rowData) => {
    return numeral(rowData.auto_end_mg_shift_hrs_aft).format('0,0');
  }
  const TPABagTemplate = (rowData) => {
    return numeral(rowData.default_tpa_bag_quantity).format('0,0');
  }
  const MaxTPABagTemplate = (rowData) => {
    return numeral(rowData.max_tpa_bag_quantity).format('0,0');
  }
  const PollHistTemplate = (rowData) => {
    return numeral(rowData.keep_plc_poll_hist_days).format('0,0');
  }
  const NoOfDaysTemplate = (rowData) => {
    return numeral(rowData.no_of_purge_days).format('0,0');
  }
  const CommitTemplate = (rowData) => {
    return numeral(rowData.commit_batch_size).format('0,0');
  }

  const HTNumber = numeral(row.default_ht_aging_hours).format('0,0');
  const RTNumber = numeral(row.default_rt_aging_hours).format('0,0');
  const MGBeforeNumber = numeral(row.auto_start_mg_shift_hrs_bef).format('0,0');
  const MGAfterNumber = numeral(row.auto_end_mg_shift_hrs_aft).format('0,0');
  const TPABagNumber = numeral(row.default_tpa_bag_quantity).format('0,0');
  const MaxTPABagNumber = numeral(row.max_tpa_bag_quantity).format('0,0');
  const PollHistNumber = numeral(row.keep_plc_poll_hist_days).format('0,0');
  const NoOfDaysNumber = numeral(row.no_of_purge_days).format('0,0');
  const CommitNumber = numeral(row.commit_batch_size).format('0,0');

  const getMaskedValue = (value) => '*'.repeat(value.length);
  // const togglePasswordVisibility = () =>setIsPasswordVisible((prev) => !prev);
  // const togglePasswordVisibility1 = () =>setIsPasswordVisible1((prev) => !prev);
  const showPassword = (id, passwordType) => {
    setVisiblePassword((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [passwordType]: true,
      }
    }))
  }
  const hidePassword = (id, passwordType) => {
    setVisiblePassword((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [passwordType]: false,
      }
    }))
  }
  const PasswordTemplate = (rowData, passwordType) => {
    const PasswordVisble = visiblePassword[rowData.organization_id]?.[passwordType] || false;
    return (
      <span onMouseDown={() => showPassword(rowData.organization_id, passwordType)} onMouseUp={() => hidePassword(rowData.organization_id, passwordType)} onMouseLeave={() => hidePassword(rowData.organization_id, passwordType)}>
        {PasswordVisble ? rowData[passwordType] : getMaskedValue(rowData[passwordType])}
      </span>
    )
  }

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const CardComponent = ({title, data}) => {
    const rightAlignedLabels = ["Poll Data ftp Server Port# : ", "Re-ftp files hours : ", "Default HT Aging Hours : ", "Default RT Aging Hours : ",
      "Auto Start MG Shift Hours Before : ", "Auto End MG Shift Hours Afters : ", "TPA Default Day Running Time : ", "Default TPA Bag Quantity : ",
      "Maximum TPA Bag Quantity : ", "Keep Poll History Days : ", "Max No of Days data Purge : ", "Commit Num of Rows : ","Archive Sever Port# : "
    ]
    const passwordLabels = ["Poll Data ftp Password : ","Archive Sever ftp Password : ", "Data Logger csv Pwd : ",]
    return (
      <Card className="card-containers">
        <h5  style={{"fontWeight":"bold"}}> {title} </h5>
        <Divider className="my-2" />
        {data.map((item, index) => (
          <div key={index} className="label-value-pair">
            <span className="label">{item.label}</span>
            {item.label==="Poll Data ftp Password : " && 
            <span 
            onMouseDown={() => setIsPasswordVisible(true) } 
            onMouseUp={() => setIsPasswordVisible(false)} 
            onMouseLeave={() => setIsPasswordVisible(false)}
            style={{cursor:"pointer"}}
            className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
              {passwordLabels.includes(item.label) ? isPasswordVisible ? item.value : getMaskedValue(item.value):
              item.value}</span>
            }
            {item.label==="Archive Sever ftp Password : " && 
            <span 
            onMouseDown={() => setIsPasswordVisible1(true) } 
            onMouseUp={() => setIsPasswordVisible1(false)} 
            onMouseLeave={() => setIsPasswordVisible1(false)}
            style={{cursor:"pointer"}}
            className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
              {passwordLabels.includes(item.label) ? isPasswordVisible1 ? item.value : getMaskedValue(item.value):
              item.value}</span>
            }
            {item.label==="Data Logger csv Pwd : " && 
            <span 
            onMouseDown={() => setIsPasswordVisible2(true) } 
            onMouseUp={() => setIsPasswordVisible2(false)} 
            onMouseLeave={() => setIsPasswordVisible2(false)}
            style={{cursor:"pointer"}}
            className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
              {passwordLabels.includes(item.label) ? isPasswordVisible2 ? item.value : getMaskedValue(item.value):
              item.value}</span>
            }
            {item.label!=="Poll Data ftp Password : " && item.label!=="Archive Sever ftp Password : " && item.label!=="Data Logger csv Pwd : " &&
            <span         
            className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
              {item.value}</span>
            }
            
          </div>
        ))}
      </Card>
    )
  }

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">System Options</div> */}
        <Tooltip target=".keep_plc_poll_hist_days-header-tooltip" content="How many days of legacy poll history to be kept (in zzpdc_plc_polling_intf_hist)" position="top"/>
        <Tooltip target=".no_of_purge_days-header-tooltip" content="Max Num of days of data to purge in single program run" position="top"/>
        <Tooltip target=".commit_batch_size-header-tooltip" content="Used for purging data from zzpdc_plc_polling_intf_hist" position="top"/>
        <Tooltip target=".poll_data_arch_host_name-header-tooltip" content="The archive text files are stored in this server (generally a Windows Server)" position="top"/>
        <Tooltip target=".poll_data_dxp_host_name-header-tooltip" content="The server where the Poll Data csv files are stored." position="top"/>
        <Tooltip target=".poll_data_dxp_remote_base_dir-header-tooltip" content="Base directory underneath subfolders suchas 2024/11 are available." position="top"/>
        <Tooltip target=".poll_data_dxp_local_base_dir-header-tooltip" content="This is Oracle Directory such as ZZPDC_OUT_DIR" position="top"/>
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="file_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={pecaPageRows}
          rowsPerPageOptions={pecaRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
        >
    
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="organization_code" header="Organization Code" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="allow_negative_inventory_mean" header="Allow Negative Inventory?" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="intransit_subinventory_code" header="Intrasit Subinventory" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="default_ht_aging_hours" header="Default HT Aging Hours" body={HTTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="default_rt_aging_hours" header="Default RT Aging Hours" body={RTTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="auto_start_mg_shift_hrs_bef" header="Auto Start MG Shift Hours Before" body={MGBeforeTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="auto_end_mg_shift_hrs_aft" header="Auto End MG Shift Hours After" body={MGAfterTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="tpa_default_day_running_time" header="TPA Default Day Running Time" sortable style={{whiteSpace: 'nowrap', textAlign:'right' }}></Column>
          <Column field="pdcs_start_eff_date" header="PDCS Start Eff Date" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="conc_pgm_pdcs_user_name" header="Conc Pgm PDCS User" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="conc_pgm_rpt_user_name" header="Conc Rpt Submit User" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="conc_pgm_rpt_resp_name" header="Conc Rpt Submit Resp" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="conc_pgm_rpt_resp_appl_name" header="Conc Rpt Submit Resp App" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="log_prefix_name" header="Log Prefix Name" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="enable_db_log_meaning" header="Enable DB Log" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="default_tpa_bag_quantity" header="Default TPA Bag Quantity" body={TPABagTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="max_tpa_bag_quantity" header="Maximum TPA Bag Quantity" body={MaxTPABagTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="keep_plc_poll_hist_days" header={<span className="keep_plc_poll_hist_days-header-tooltip">Keep Poll History Days</span>} body={PollHistTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="no_of_purge_days" header={<span className="no_of_purge_days-header-tooltip">Max No of Days data Purge</span>} body={NoOfDaysTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="commit_batch_size" header={<span className="commit_batch_size-header-tooltip">Commit Num of Rows</span>} body={CommitTemplate} sortable style={{whiteSpace: 'nowrap', textAlign: 'right' }}></Column>
          <Column field="poll_data_arch_host_name" header={<span className="poll_data_arch_host_name-header-tooltip">Archive Sever IP Address</span>} sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="poll_data_arch_port_number" header="Archive Sever Port#" sortable style={{whiteSpace: 'nowrap', textAlign:'right' }}></Column>
          <Column field="poll_data_arch_ftp_user" header="Archive Sever ftp User" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="poll_data_arch_ftp_password" header="Archive Sever ftp Password" body={(rowData) => PasswordTemplate(rowData, 'poll_data_arch_ftp_password')} sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="poll_data_dxp_host_name" header={<span className="poll_data_dxp_host_name-header-tooltip">Poll Data ftp Server</span>} sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="poll_data_dxp_port_number" header="Poll Data ftp Server Port#" sortable style={{whiteSpace: 'nowrap', textAlign:'right' }}></Column>
          <Column field="poll_data_dxp_ftp_user" header="Poll Data ftp User" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="poll_data_dxp_ftp_password" header="Poll Data ftp Password" body={(rowData) => PasswordTemplate(rowData,'poll_data_dxp_ftp_password')} sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="poll_data_dxp_remote_base_dir" header={<span className="poll_data_dxp_remote_base_dir-header-tooltip">Poll Data server Base Directory</span>} sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="poll_data_dxp_local_base_dir" header={<span className="poll_data_dxp_local_base_dir-header-tooltip">Poll Data Oracle server Base Directory</span>} sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="dxp_dlog_logging_path" header="Data Logger Logging Path" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="dxp_dlog_csv_domain" header="Data Logger csv domain" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="dxp_dlog_csv_uid" header="Data Logger csv UID" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="dxp_dlog_csv_pwd" header="Data Logger csv Pwd"  body={(rowData) => PasswordTemplate(rowData,'dxp_dlog_csv_pwd')} sortable style={{whiteSpace: 'nowrap' }}></Column>
        </DataTable>
      </div>
      )}

      <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                <h4 style={{"fontWeight":"bold"}}> System Options </h4>
                <Divider className="my-4" />
                <h5 style={{"fontWeight":"bold"}}> View System Options </h5>
                <Divider className="my-4" />
                <div className="card-wrapper">
                  <CardComponent
                    title="Organization and Inventory Details"
                    data={[
                      {label:"Organization Code : ", value: row.organization_code },
                      {label:"Allow Negative Inventory? : ", value: row.allow_negative_inventory_mean },
                      {label:"Intrasit Subinventory : ", value: row.intransit_subinventory_code },
                    ]}
                  />
                  <CardComponent
                    title="Poll Data ftp Info"
                    data={[
                      {label:"Poll Data ftp Server : ", value: row.poll_data_dxp_host_name },
                      {label:"Poll Data ftp Server Port# : ", value: row.poll_data_dxp_port_number },
                      {label:"Poll Data ftp User : ", value: row.poll_data_dxp_ftp_user },
                      {label:"Poll Data ftp Password : ", value:  isPasswordVisible ? row.poll_data_dxp_ftp_password : getMaskedValue(row.poll_data_dxp_ftp_password)},
                      {label:"Poll Data ftp Base Directory : ", value: row.poll_data_dxp_remote_base_dir },
                    ]}
                  />
                  <CardComponent
                    title="Data Logger Info"
                    data={[
                      {label:"Data Logger Logging Path : ", value: row.dxp_dlog_logging_path },
                      {label:"Data Logger csv domain : ", value: row.dxp_dlog_csv_domain },
                      {label:"Data Logger csv UID : ", value: row.dxp_dlog_csv_uid },
                      {label:"Data Logger csv Pwd : ", value: isPasswordVisible2 ? row.dxp_dlog_csv_pwd : getMaskedValue(row.dxp_dlog_csv_pwd) },
                    ]}
                  />
                  <CardComponent
                    title="Aging Details"
                    data={[
                      {label:"Default HT Aging Hours : ", value: HTNumber },
                      {label:"Default RT Aging Hours : ", value: RTNumber },
                    ]}
                  />
                  <CardComponent
                    title="Shift Details"
                    data={[
                      {label:"Auto Start MG Shift Hours Before : ", value: MGBeforeNumber },
                      {label:"Auto End MG Shift Hours Afters : ", value: MGAfterNumber },
                      {label:"TPA Default Day Running Time : ", value: row.tpa_default_day_running_time },
                      {label:"PDCS Start Eff Date : ", value: row.pdcs_start_eff_date },
                    ]}
                  />
                  <CardComponent
                    title="Concurent Request Details"
                    data={[
                      {label:"Conc Pgm PDCS User : ", value: row.conc_pgm_pdcs_user_name },
                      {label:"Conc Rpt Submit User : ", value: row.conc_pgm_rpt_user_name },
                      {label:"Conc Rpt Submit Resp : ", value: row.conc_pgm_rpt_resp_name },
                      {label:"Conc Rpt Submit Resp App : ", value: row.conc_pgm_rpt_resp_appl_name },
                    ]}
                  />
                  <CardComponent
                    title="Log Details"
                    data={[
                      {label:"Log Prefix Name : ", value: row.log_prefix_name },
                      {label:"Enable DB Log : ", value: row.enable_db_log_meaning },
                    ]}
                  />
                 <CardComponent
                    title="Bag Quantity  Details"
                    data={[
                      {label:"Default TPA Bag Quantity : ", value: TPABagNumber },
                      {label:"Maximum TPA Bag Quantity : ", value: MaxTPABagNumber },
                    ]}
                  />
                  <CardComponent
                    title="Poll Data Archive Details"
                    data={[
                      {label:"Keep Poll History Days : ", value: PollHistNumber },
                      {label:"Max No of Days data Purge : ", value: NoOfDaysNumber },
                      {label:"Commit Num of Rows : ", value: CommitNumber },
                    ]}
                  />
                  <CardComponent
                    title="Legacy Poll Data Archive Server Info"
                    data={[
                      {label:"Archive Sever IP Address : ", value: row.poll_data_arch_host_name },
                      {label:"Archive Sever Port# : ", value: row.poll_data_arch_port_number },
                      {label:"Archive Sever ftp User : ", value: row.poll_data_arch_ftp_user },
                      {label:"Archive Sever ftp Password : ", value: isPasswordVisible1 ? row.poll_data_arch_ftp_password : getMaskedValue(row.poll_data_arch_ftp_password) },
                    ]}
                  />
                   <CardComponent
                    title="Others"
                    data={[
                      {label:"Poll Data Oracle server Base Directory : ", value: row.poll_data_dxp_local_base_dir },
                    ]}
                  />
                 </div>
            </Dialog>
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{ width: '400px' }} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            <style jsx>{`
              .card-wrapper {
                display: grid;
                grid-template-columns: repeat(4,1fr);
                gap: 10px;
                padding: 5px;
              }

              .card-containers {
                display: flex;
                background-color: #f9f9f9;
                flex-direction: column;
                justify-content: flex-start;
                border: 1px solid #ccc;
                paddig: 10px;
                box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                height: auto;
                width: 100%;
              }

              .label-value-pair {
                display: flex;
                flex-direction: row,
                align-items: flex-start;
                gap: 5px;
                margin-bottom: 8px;
                flex-wrap: wrap;
              }

              .label {
                font-weight: bold;
                white-space: nowrap;
              }

              .value-box {
                background-color:rgb(235, 235, 235);
                padding: 6px 10px;
                border-radius: 4px;
                display: block;
                word-wrap: break-word;
                overflow-wrap: break-word;
                flex-grow: 1;
                min-width: 0;
              }

              .align-right {
                text-align: right;
                background-color:rgb(235, 235, 235);
                padding: 6px 10px;
                border-radius: 4px;
                display: block;
                word-wrap: break-word;
                overflow-wrap: break-word;
                flex-grow: 1;
                min-width: 0;
              }
            `}
            </style>
            </div>
    </div>
  );
};

export default SystemOptions;

